import { _initialState } from './_initialState';
import {
  addSkuDimensions,
  getSkuProductDimensions,
  updateStackDimensions,
  initializeSkuDimensions,
} from './actions';

export const dimensionsStore = (set, get) => ({
  ..._initialState,
  getSkuProductDimensions: (
    key
  ) => getSkuProductDimensions(
    set,
    get,
    key
  ),
  addSkuDimensions: (
    key,
    value
  ) => addSkuDimensions(
    set,
    get,
    key,
    value
  ),
  initializeSkuDimensions: (
    dimensions
  ) => initializeSkuDimensions(
    set,
    get,
    dimensions
  ),
  updateStackDimensions: (
    dimensions
  ) => updateStackDimensions(
    set,
    get,
    dimensions
  ),
  resetDimensions: () => set(
    _initialState,
    false,
    { type: 'RESET' }
  ),
});
